import { render, staticRenderFns } from "./employee-accesses.vue?vue&type=template&id=010befa5"
import script from "./employee-accesses.vue?vue&type=script&lang=js"
export * from "./employee-accesses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports